import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth';
import { Header } from './Header';
import { PrefetchRepoOnHover } from '../PrefetchRepoOnHover';
import './MainLayout.css';

interface MainLayoutProps {
    requireAuth?: boolean;
}

export function MainLayout({ requireAuth = false }: MainLayoutProps) {
    const { isAuthenticated, isLoading } = useAuthStore();

    // 需要认证但未登录
    if (requireAuth && !isAuthenticated && !isLoading) {
        return <Navigate to="/login" replace />;
    }

    return (
        <div className="main-layout">
            <PrefetchRepoOnHover />
            <Header />
            <main className="main-content">
                <Outlet />
            </main>
        </div>
    );
}
